
(function() {
  var result = { translations: { "es-mx": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es-mx": "static-7.787"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.787",
    "ar-eg": "static-7.787",
    "bg": "static-7.787",
    "bn": "static-7.787",
    "ca-es": "static-7.787",
    "cs": "static-7.787",
    "da": "static-7.787",
    "de": "static-7.787",
    "el": "static-7.787",
    "en-gb": "static-7.787",
    "en": "static-7.787",
    "es-mx": "static-7.787",
    "es": "static-7.787",
    "fi": "static-7.787",
    "fr-ca": "static-7.787",
    "fr": "static-7.787",
    "he-il": "static-7.787",
    "hr": "static-7.787",
    "hu": "static-7.787",
    "id": "static-7.787",
    "it": "static-7.787",
    "ja": "static-7.787",
    "ko": "static-7.787",
    "lt": "static-7.787",
    "ms": "static-7.787",
    "nl": "static-7.787",
    "no": "static-7.787",
    "pl": "static-7.787",
    "pt-br": "static-7.787",
    "pt-pt": "static-7.787",
    "ro": "static-7.787",
    "ru": "static-7.787",
    "sk": "static-7.787",
    "sl": "static-7.787",
    "sv": "static-7.787",
    "th": "static-7.787",
    "tl": "static-7.787",
    "tr": "static-7.787",
    "uk": "static-7.787",
    "vi": "static-7.787",
    "x-pseudo": "static-7.787",
    "zh-cn": "static-7.787",
    "zh-hk": "static-7.787",
    "zh-tw": "static-7.787"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es-mx', {version: 'static-7.787'}); }
})();


